import { createSlice } from '@reduxjs/toolkit';

const sampleQnA = [
  // { message: '채팅상담 && 전화상담', type: 'Q', idx: 0 },
  // {
  //   message: '개인정보는 제공하지 않습니다. 채팅상담 또는 전화상담을 이용해보세요.',
  //   type: 'A',
  //   idx: 1,
  // },
  // { message: '채팅상담', type: 'Q', idx: 2 },
  // {
  //   message: '개인정보는 제공하지 않습니다. 채팅상담을 이용해보세요.',
  //   type: 'A',
  //   idx: 3,
  // },
  // { message: '홈화면 && 우측상단 && 내정보', type: 'Q', idx: 4 },
  // {
  //   message: '홈화면 > 우측상단 내정보 메뉴를 이용하세요.',
  //   type: 'A',
  //   idx: 5,
  // },
  // { message: '홈화면 && 연말정산 && 일정', type: 'Q', idx: 6 },
  // {
  //   message: '홈화면 > 연말정산 일정 메뉴에서 확인할 수 있습니다.',
  //   type: 'A',
  //   idx: 7,
  // },
  // { message: '연말정산 일정', type: 'Q', idx: 8 },
  // {
  //   message: '연말정산 일정 메뉴에서 확인할 수 있습니다.',
  //   type: 'A',
  //   idx: 9,
  // },
  // { message: '채팅상담 && 전화상담 + 홈화면 && 우측상단 && 내정보', type: 'Q', idx: 10 },
  // {
  //   message:
  //     '모바일 홈화면 -> 우측상단 내정보 메뉴를 이용하세요. 주소 변경과 관련된 추가적인 도움이 필요하시면 채팅상담 또는 전화상담을 이용해 보세요.',
  //   type: 'A',
  //   idx: 11,
  // },
  // { message: '월급날 제출 후 수정 가능한지 궁금해', type: 'Q', idx: 12 },
  // {
  //   message: '홈화면 -> 시작 -> 결과조회 -> 초기화 버튼을 이용하여 다시 입력할 수 있습니다.',
  //   type: 'A',
  //   idx: 13,
  // },
  // { message: '월급날 제출 후 수정 가능한지 궁금해', type: 'Q', idx: 14 },
  // {
  //   message: '오류가 발생했습니다.',
  //   type: 'error',
  //   idx: 15,
  // },
  { message: '수식을 이용한 답변', type: 'Q', idx: 16 },
  {
    message:
      '1. **최저 사용 금액**: 총급여의 25%\n' +
      '\\[80,000,000 \\times 0.25 = 20,000,000\\text{ 원}\\]\n\n' +
      '2. **초과 사용 금액**: 신용카드 사용액 - 최저 사용 금액\n' +
      '\\[76,600,000 - 20,000,000 = 56,600,000\\text{ 원}\\]\n\n' +
      '3. **공제율**: 일반 신용카드 사용액에 대한 공제율은 15%입니다.\n\n' +
      '4. **공제 가능 금액**: 초과 사용 금액에 공제율을 적용\n' +
      '\\[56,600,000 \\times 0.15 = 8,490,000\\text{ 원}\\]',
    type: 'A',
    idx: 17,
  },
  { message: '연금저축 세액공제 계산', type: 'Q', idx: 18 },
  {
    message: `1. **일반공제금액**:
     - \\(\\text{일반공제금액} = \\min(\\text{연금저축 납입액} + \\text{퇴직연금계좌 납입액}, 900 \\text{만 원})\\)
     - 연금저축 납입액은 최대 600만 원까지 인정됩니다.

  2. **ISA 전환금액에 대한 추가공제금액**:
     - \\(\\text{ISA 추가공제금액} = \\min(\\text{전환금액} \\times 10\\%, 300 \\text{만 원})\\)
     - 전환금액은 ISA 만기 금액 중 연금계좌로 입금한 금액입니다.

  3. **공제대상금액**:
     - \\(\\text{공제대상금액} = \\text{일반공제금액} + \\text{ISA 추가공제금액}\\)

  ### 세액공제액 계산

  - **세액공제율**:
    - 총급여액이 5,500만 원 이하인 경우: 15%
    - 총급여액이 5,500만 원을 초과하는 경우: 12%

  - **세액공제액**:
    - \\(\\text{세액공제액} = \\text{공제대상금액} \\times \\text{세액공제율}\\)

  ## 예시

  예를 들어, 연금저축 납입액이 600만 원, 퇴직연금계좌 납입액이 300만 원, ISA 전환금액이 4,000만 원인 경우:

  - **일반공제금액**: \\(\\min(600 + 300, 900) = 900 \\text{만 원}\\)
  - **ISA 추가공제금액**: \\(\\min(4,000 \\times 10\\%, 300) = 300 \\text{만 원}\\)
  - **공제대상금액**: \\(900 + 300 = 1,200 \\text{만 원}\\)`,
    type: 'A',
    idx: 19,
  },
  {
    message: '복잡한 세액공제 계산식에 대해 알려줘',
    type: 'Q',
    idx: 20,
  },
  {
    message: `복잡하게 이루어질 수 있습니다. 여기서는 일반적인 세액공제 계산의 예시를 복잡한 수식 형태로 설명하겠습니다.
  ### 세액공제 계산식
  1. **연금계좌 세액공제**:
     \\[
     \\text{세액공제액} = \\text{Min}\\left(\\text{연금저축 납입액}, 600\\text{만 원}\\right) \\times \\text{세액공제율} + \\text{Min}\\left(\\text{퇴직연금 납입액}, 300\\text{만 원}\\right) \\times \\text{세액공제율}
     \\]
     \\[
     \\text{세액공제율} =
     \\begin{cases}
     15\\% & \\text{총급여액} \\leq 5,500\\text{만 원} \\\\
     12\\% & \\text{총급여액} > 5,500\\text{만 원}
     \\end{cases}
     \\]
  2. **신용카드 소득공제**:
     \\[
     \\text{소득공제액} =
     \\begin{cases}
     0 & \\text{신용카드 사용금액} \\leq \\text{총급여액} \\times 0.25 \\\\
     \\left(\\text{신용카드 사용금액} - \\text{총급여액} \\times 0.25\\right) \\times \\text{공제율} & \\text{신용카드 사용금액} > \\text{총급여액} \\times 0.25
     \\end{cases}
     \\]
     \\[
     \\text{공제율} =
     \\begin{cases}
     15\\% & \\text{일반 사용분} \\\\
     30\\% & \\text{전통시장, 대중교통 사용분} \\\\
     40\\% & \\text{도서, 공연 사용분}
     \\end{cases}
     \\]
  3. **의료비 세액공제**:
     \\[
     \\text{의료비 공제액} = \\text{의료비 지출액} - \\text{총급여액} \\times 0.03
     \\]
     단, 본인, 6세 이하 자녀, 65세 이상 부모, 장애인에 대한 의료비는 전액 공제 가능
  4. **기부금 세액공제**:
     \\[
     \\text{기부금 공제액} = \\text{기부금} \\times
     \\begin{cases}
     15\\% & \\text{기부금} \\leq 1,000\\text{만 원} \\\\
     30\\% & \\text{기부금} > 1,000\\text{만 원}
     \\end{cases}
     \\]
  이러한 계산식은 각 항목의 조건과 한도에 따라 달라질 수 있으며, 실제 계산 시에는 각 항목의 세부 조건을 정확히 반영해야 합니다. 연말정산 시스템을 통해 보다 정확한 계산을 진행할 수 있습니다. 추가적인 정보가 필요하시면 말씀해 주세요.`,
    type: 'A',
    idx: 21,
  },
  {
    message: '연금저축 세액공제 계산식을 알려줘',
    type: 'Q',
    idx: 22,
  },
  {
    message: `## 📋 연말정산 세법 정보
- 제공해주신 웹 검색 결과에 따르면, 결혼세액공제는 신설된 제도로서 2024년부터 2026년 사이에 혼인신고를 완료한 신혼부부에게 생애 1회, 근로자 본인과 배우자 각각 50만원(최대 합계 100만원)의 세액공제를 적용합니다.  
- 따라서 질문 주신 “2027년에 결혼(혼인신고) 예정”인 경우에는, 현재 공개된 정보 기준으로는 결혼세액공제 적용 대상 기간(’24.1.1.~’26.12.31. 혼인신고 완료)에 포함되지 않습니다.  
- 결론: 2027년에 혼인신고를 하신다면, 현 검색 결과에 있는 제도 범위로는 결혼세액공제를 받을 수 없습니다. 다만 세법은 개정될 수 있으므로, 2027년 이전에 정부·국세청의 공식 발표나 연말정산 공지에서 대상 기간 연장 여부를 확인하시길 권합니다.  
- 참고로, 공제를 받기 위해서는 혼인신고가 필수이며, 공제는 혼인신고가 이루어진 연도에 1회 적용됩니다.

---
## 🔗 출처
[[한국세정신문] 작년 결혼했는데 언제까지 혼인신고해야 결혼세액공제 받나?](https://www.taxtimes.co.kr/mobile/article.html?no=268118)
[[한국세정신문] [2025년 달라지는 조세제도-下]결혼세액공제 제도 신설](https://www.taxtimes.co.kr/news/article.html?no=267787)
[결혼세액공제, 최대 100만 원? 연말정산 및 ...](https://www.banksalad.com/articles/세금환급-일반세액공제-결혼세액공제)
[[한국세정신문] 신혼부부라면, 최대 100만원 결혼세액공제 잊지 마세요](https://taxtimes.co.kr/mobile/article.html?no=268117)
[신혼부부면 최대 100만원 세액공제…'13월 월급' 더 받는 꿀팁 | 중앙일보](https://www.joongang.co.kr/article/25308529)
[[2025 연말정산 총정리] 달라진 세법 개정 사항부터 절차까지, 쉽게 알려드립니다! - 네이버웍스](https://naver.worksmobile.com/blog/year-end-tax-2025/)
[2025년 연말정산 결혼 세액공제 정리(대상, 기간, 공제 금액)](https://mity.tistory.com/entry/2025-%EA%B2%B0%ED%98%BC-%EC%84%B8%EC%95%A1%EA%B3%B5%EC%A0%9C)
[신혼부부, 연내 혼인신고땐 최대 100만원 돌려받아요 | 한국경제](https://www.hankyung.com/article/2024122227631)
[국세청 “꿀 같은 신혼, 최대 100만원의 결혼세액공제 잊지 마세요” - 조선비즈](https://biz.chosun.com/policy/policy_sub/2025/01/19/ADFVQTY7OJGUNPHMIH7XTWAUW4/)
[[FAQ] 국세청이 알려 주는 신혼부부 맞춤형 연말정산 안내](https://www.sejungilbo.com/news/articleView.html?idxno=51593)`,
    type: 'A',
    idx: 25,
  },
];

const initialState = {
  // qnaList: sampleQnA,
  qnaList: [],
  qContent: '',
  authInfo: {
    sessionId: '',
    htmPerSabun: '',
    htmAlias: '',
    platformFlag: '',
  },
  isLoading: false,
  hasError: false,
};

export const aiAssistantSlice = createSlice({
  name: 'aiAssistant',
  initialState,
  reducers: {
    setQnaList: (state, action) => {
      state.qnaList = action.payload;
    },
    setQContent: (state, action) => {
      state.qContent = action.payload;
    },
    setAuthInfo: (state, action) => {
      state.authInfo = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setHasError: (state, action) => {
      state.hasError = action.payload;
    },
    resetAiAssistantState: state => {
      return initialState;
    },
  },
});

export const {
  setQnaList,
  setQContent,
  setAuthInfo,
  setIsLoading,
  setHasError,
  resetAiAssistantState,
} = aiAssistantSlice.actions;

export default aiAssistantSlice.reducer;
